export default __webpack_public_path__ + "static/media/bsc.2a9158a4.png";